// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { HireOpenYoungInterveners } = require('components/hire/hireOpenYoungInterveners/hireOpenYoungInterveners');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @ constants
const {
    ACCOUNT_INTERVENTION_OWNER,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    THIRD_STEP,
} = require('constants/index');

const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');

class HirePackOpenYoungStep3 extends React.Component {

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    filterAccounts() {
        const { immAccounts } = this.props;

        const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            immAccounts.getIn(['byId', accountId, 'interventionType']) === ACCOUNT_INTERVENTION_OWNER
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            handleAccountChange,
            immAccounts,
            immHireOpenYoungInterveners,
            immHirePackOpenYoung,
            immOpenYoungPersonalData,
            isInactiveAccountsEnabled,
        } = this.props;
        const immStep3 = immHirePackOpenYoung.getIn(['steps', THIRD_STEP]);
        const accountErrorMsgVisible = immStep3.get('accountIsDirty') && !immStep3.get('accountIsValid');
        const accountErrorMsg = formatText('hirePackOpenYoung-hirePackOpenYoung_step3SelectAccountError');
        const accountLabel = formatText('hirePackOpenYoung-hirePackOpenYoung_step3SelectAccount');
        const minorName = immOpenYoungPersonalData.getIn(['name', 'value']);
        const minorLastName = immOpenYoungPersonalData.getIn(['lastName', 'value']);
        const minorLastName2 = immOpenYoungPersonalData.getIn(['lastName2', 'value']);
        const minorFullName = `${minorName} ${minorLastName} ${minorLastName2}`;
        const hasOnlyOneAccount = immAccounts.get('byId').size === 1;
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        let interveners;
        let initialAccountId;

        if (hasOnlyOneAccount) {
            initialAccountId = immAccounts.get('byOrder').first();
        }

        if (!!immStep3.get('accountId')) {
          interveners = (
              <HireOpenYoungInterveners
                  accountId={immStep3.get('accountId')}
                  holderName={minorFullName}
                  immHireOpenYoungInterveners={immHireOpenYoungInterveners}
              />
          );
        }

        return (
            <article className="hire-pack-open-young__step-three">
                <FormattedText
                    className="hire-pack-open-young__step-title"
                    value="hirePackOpenYoung-hirePackOpenYoung_step3Title"
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    currentAccountId={immStep3.get('accountId')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    enabled={!hasOnlyOneAccount}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    initialAccountId={initialAccountId}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    showAvailableBalance={true}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    loading={isBlockedAccountsLoading}
                />
                {interveners}
            </article>
        );
    }
}

HirePackOpenYoungStep3.propTypes = {
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireOpenYoungInterveners: PropTypes.object.isRequired,
    immHirePackOpenYoung: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
};

module.exports = HirePackOpenYoungStep3;
